const en = {
	language: {
		language: 'CN',
	},
	LOGIN: {
		txt1: 'File Management System',
		txt2: 'Account',
		txt3: 'Please enter your login account',
		txt4: 'Password',
		txt5: 'Please enter your login password',
		txt6: 'Login',
		txt7: 'Email/Account',
		txt8: 'Please enter your login email/account',
		txt9: 'Verification Code',
		txt10: 'Please enter the verification code',
		txt11: 'Password login',
		txt12: 'Verification code login',
		txt13: 'Get verification code',
		txt14: 'Resend after seconds',
		txt15: 'The email format is abnormal. Please check the email format or switch to password login.',
		txt16: 'Verification code sent successfully',
		txt17: 'Email',
		txt18: 'Please enter your login email address'
	},
	CONFIG: {
		txt1: 'File Management System',
		txt2: 'Change Password',
		txt3: 'Configuration Management',
		txt4: '1. System Administrator Configuration',
		txt5: 'Role Management:',
		txt6: 'Add Administrator (Grant backend menu management permissions)',
		txt7: 'Go to Configuration >',
		txt8: '2. Group Management (Structure & Users & Identity)',
		txt9: 'Business Role Management:',
		txt10: 'Create Administrator Role (One of the user identity groups for permission segmentation in frontend file uploads)',
		txt11: 'Go to Configuration >',
		txt12: 'Position Management:',
		txt13: 'Create Position (One of the user identity groups for permission segmentation in frontend file uploads)',
		txt14: 'Go to Configuration >',
		txt15: 'Organizational Structure Management:',
		txt16: 'Maintain the organizational structure as needed (Frontend folders and files, as well as backend users, are stored under their respective structures)',
		txt17: 'Go to Configuration >',
		txt18: 'User Management:',
		txt19: 'Create users as needed and complete user information (Configure site management rights, user identity, and file/folder operation permissions for each user)',
		txt20: 'Go to Configuration >',
		txt21: '3. Group File Management',
		txt22: 'File Type Management:',
		txt23: 'Create file types as needed (Used for selecting file categories when uploading files in the frontend)',
		txt24: 'Go to Configuration >',
		txt25: 'File Management:',
		txt26: 'View/Preview/Download files under managed sites; Search for files using filters such as file name, version number, file type, and file status.',
		txt27: 'Go to Configuration >',
		txt28: '4. Approval Management',
		txt29: 'Feature not yet available',
		txt30: 'Dashboard',
		txt31: 'Home',
		txt32: 'File Management',
		txt33: 'Approval Center',
		txt34: 'Operation Log',
		txt35: 'System under improvement'
	},
	INDEX: {
		txt1: 'File Management System',
		txt2: 'New Folder',
		txt3: 'Upload',
		txt4: 'Search File',
		txt5: 'Configure/Manage',
		txt6: 'Change Password',
		txt7: 'Logout',
		txt8: 'My Homepage',
		txt9: 'Recent Visits',
		txt10: 'Location',
		txt11: 'All',
		txt12: 'Folders',
		txt13: 'Documents',
		txt14: 'Images',
		txt15: 'Others',
		txt16: 'Back',
		txt17: 'Found "',
		txt18: '" Total ',
		txt19: ' items',
		txt20: 'Search Results for "',
		txt21: '"',
		txt22: 'Name',
		txt23: 'Type',
		txt24: 'Size',
		txt25: 'Date',
		txt26: 'Action',
		txt27: 'Current list is empty',
		txt28: 'Select a file to display its information',
		txt29: 'File Details',
		txt30: 'File Information',
		txt31: 'Type:',
		txt32: 'Location:',
		txt33: 'Owner:',
		txt34: 'Size:',
		txt35: 'Last Modified:',
		txt36: 'Last Opened:',
		txt37: 'Created On:',
		txt38: 'File Category:',
		txt39: 'File Version:',
		txt40: 'Action',
		txt41: 'View',
		txt42: 'Download',
		txt43: 'Print',
		txt44: 'Edit',
		txt45: 'Update',
		txt46: 'Invalidate',
		txt47: 'Version History',
		txt48: 'Uploaded On',
		txt49: 'Main Version',
		txt50: 'Operation Log',
		txt51: 'Under Development...',
		txt52: 'Confirm Delete This Folder?',
		txt53: 'Notice',
		txt54: 'Confirm',
		txt55: 'Cancel',
		txt56: 'Deleted Successfully',
		txt57: 'Confirm Logout?',
		txt58: 'Logout Successful',
		txt59: 'Create Subfolder',
		txt60: 'Upload File',
		txt61: 'Edit Folder',
		txt62: 'Delete Folder',
		txt63: 'Creator',
		txt64: 'Transfer',
		txt65: 'File Number:'
	},
	ADDEDIT: {
	    txt1: 'Upload File',
		txt2: 'Update File',
		txt3: 'Edit File',
		txt4: 'Selected File',
		txt5: 'Click to Upload',
		txt6: 'File Name',
		txt7: 'Enter File Name',
		txt8: 'File Number',
		txt9: 'Enter File Number',
		txt10: 'Version Number',
		txt11: 'Enter Version Number',
		txt12: 'File Category',
		txt13: 'Please Select a File Category',
		txt14: 'File Description',
		txt15: 'Please describe the purpose of this file or what content has been optimized in this version',
		txt16: 'File Authorization',
		txt17: 'Notice:',
		txt18: 'By default, the uploader has the rights to invalidate and delete the file;',
		txt19: 'View / Download Permissions',
		txt20: 'By Department',
		txt21: 'Select Department & Site',
		txt22: 'By Role',
		txt23: 'By Position',
		txt24: 'By User',
		txt25: 'Select User',
		txt26: 'Edit Permission',
		txt27: 'Update Permission',
		txt28: 'Cancel',
		txt29: 'Submit',
		txt30: 'Upload Successful',
		txt31: 'Edit Successful',
		txt32: 'Update Successful',
		txt33: 'Please upload a file first',
		txt34: 'Incorrect file type. Allowed types are: png, jpg, jpeg, pdf, webp, xls, xlsx, txt, csv, doc, docx, ppt, pptx, zip, mp3, mp4, avi',
		txt35: 'Uploading files larger than 10MB is not supported!',
		txt36: 'This field is not editable'
	},
	ADDSITE: {
		txt1: 'Select Department & Site',
		txt2: 'Cancel',
		txt3: 'Confirm',
		txt4: 'Please select a department or site first'
	},
	ADDUSER: {
		txt1: 'Select User',
		txt2: 'Please select a user',
		txt3: 'Cancel',
		txt4: 'Confirm',
		txt5: 'Please select a user first'
	},
	CREATEFOLDER: {
		txt1: 'Create New Folder',
		txt2: 'Edit Folder',
		txt3: 'Folder Name',
		txt4: 'Enter your folder name',
		txt5: 'Create',
		txt6: 'Confirm',
		txt7: 'Cancel',
		txt8: 'Creation failed, folder already exists / Creation failed, name cannot be empty',
		txt9: 'Modification Successful',
		txt10: 'Creation Successful'
	},
	DEL: {
		txt1: 'Delete File',
		txt2: 'Invalidate File',
		txt3: 'Notice: Invalidated files are retained permanently',
		txt4: 'Selected File',
		txt5: 'File Size',
		txt6: 'File Number',
		txt7: 'Reason Description',
		txt8: 'Please describe the reason for deleting the file',
		txt9: 'Please describe the reason for invalidating the file',
		txt10: 'Cancel',
		txt11: 'Submit',
		txt12: 'Please provide a reason',
		txt13: 'Invalidation Successful'
	},
	PWD: {
		txt1: 'First-time Login Password Change',
		txt2: 'Set Password',
		txt3: 'Enter Old Password',
		txt4: 'Set Password',
		txt5: 'Re-enter Password',
		txt6: 'Cancel',
		txt7: 'Confirm',
		txt8: 'Old password and new password cannot be the same',
		txt9: 'New password cannot be the default password',
		txt10: 'New password and confirmation password do not match',
		txt11: 'Password Reset Successful'
	},
	MOVESITE: {
		txt1: 'File Transfer',
		txt2: 'File name: ',
		txt3: 'Current location: ',
		txt4: 'Please select the location you want to move: ',
		txt5: 'Please select the location you want to move to first',
		txt6: 'Transfer Successful'
	}
};
export default en